export const PAY_TAGS = { distance: ["مسافة", "bg-emerald-100 text-emerald-800 ring-1 ring-emerald-300"], target: ["تارقت", "bg-amber-100 text-amber-800 ring-1 ring-amber-300"], invoice: ["فري لانسر", "bg-violet-100 text-violet-800 ring-1 ring-violet-300"] };
export const payModeOf = (row) => row.pay_mode || (row.is_freelance ? "invoice" : "");
const fmtN = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
export const CompareChip = ({ row, id = row.id, onSwitch, busy }) => {
  const c = row.compare;
  if (!c) return null;
  const other = c.current === "distance" ? "target" : "distance";
  const diff = Math.round((c.distance_net - c.target_net) * 100) / 100;
  const best = diff > 0 ? "distance" : diff < 0 ? "target" : "";
  const cls = (k) => (best === k ? "font-bold text-emerald-700" : "text-slate-500");
  return (
    <span className="mt-0.5 flex flex-wrap items-center gap-1 text-[10px]" data-testid={`salary-compare-${id}`}
      title="صافي الراتب التقديري لو حُسب بكل طريقة (نفس الخصومات)">
      <span className={cls("target")}>تارقت {fmtN(c.target_net)}</span><span className="text-slate-300">|</span>
      <span className={cls("distance")}>مسافة {fmtN(c.distance_net)}</span>
      {best && best !== c.current && <span className="rounded bg-rose-50 px-1 font-semibold text-rose-600" data-testid={`salary-compare-hint-${id}`}>
        {best === "distance" ? "المسافة" : "التارقت"} أفضل له بـ {fmtN(Math.abs(diff))}</span>}
      {onSwitch && <button type="button" disabled={busy} onClick={(e) => { e.stopPropagation(); onSwitch(row, other); }} data-testid={`salary-switch-${id}`}
        className="rounded border border-blue-200 bg-blue-50 px-1.5 font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50">
        {busy ? "…" : `انقل إلى ${other === "distance" ? "هنجر مسافات" : "هنجر تارقت"}`}</button>}
      {onSwitch && row.pay_mode_override && <button type="button" disabled={busy} onClick={(e) => { e.stopPropagation(); onSwitch(row, ""); }} data-testid={`salary-switch-auto-${id}`}
        className="rounded px-1 text-slate-400 underline hover:text-slate-600" title="إلغاء النقل اليدوي والرجوع لاختيار الصفحات في الإعدادات">إلغاء النقل</button>}
    </span>
  );
};
export const PayModeTag = ({ row, id = row.id }) => {
  const t = PAY_TAGS[payModeOf(row)];
  return t ? <span className={`ms-1 rounded-full px-2 py-0.5 text-[11px] font-bold ${t[1]}`} data-testid={`salary-paymode-${id}`}>{t[0]}</span> : null;
};


export const CostSummary = ({ rows }) => {
  const withC = rows.filter((r) => r.compare);
  if (!withC.length) return null;
  const sum = (f) => Math.round(rows.reduce((a, r) => a + (r.compare ? f(r.compare) : Number(r.values?.net_salary || 0)), 0) * 100) / 100;
  const cur = sum((c) => (c.current === "distance" ? c.distance_net : c.target_net));
  const allT = sum((c) => c.target_net), allD = sum((c) => c.distance_net), best = sum((c) => Math.min(c.target_net, c.distance_net));
  const Box = ({ k, l, v, tone }) => (
    <div className="rounded-xl border border-slate-200 bg-white p-3" data-testid={`cost-sum-${k}`}>
      <p className="text-[11px] text-slate-500">{l}</p>
      <p className={`font-heading text-lg font-bold tabular-nums ${tone}`}>{fmtN(v)} <span className="text-xs">ر.س</span></p>
      {k !== "current" && <p className={`text-[11px] font-semibold ${v < cur ? "text-emerald-600" : v > cur ? "text-rose-600" : "text-slate-400"}`}>{v === cur ? "مثل الحالي" : `${v < cur ? "أوفر" : "أعلى"} بـ ${fmtN(Math.abs(v - cur))}`}</p>}
    </div>
  );
  return (
    <div className="rounded-2xl border border-indigo-200 bg-indigo-50/40 p-3" data-testid="salary-cost-summary">
      <p className="mb-2 text-sm font-bold text-indigo-800">تكلفة الشهر: تارقت مقابل مسافة <span className="text-[11px] font-normal text-slate-500">(صافي تقديري لـ {withC.length} مندوب بنفس الخصومات)</span></p>
      <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
        <Box k="current" l="التكلفة الحالية" v={cur} tone="text-slate-800" />
        <Box k="target" l="لو الكل بالتارقت" v={allT} tone="text-amber-700" />
        <Box k="distance" l="لو الكل بالمسافة" v={allD} tone="text-emerald-700" />
        <Box k="best" l="الأوفر للشركة لكل مندوب" v={best} tone="text-indigo-700" />
      </div>
    </div>
  );
};
